
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"aria-hidden":"true","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 34"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.697 9.338L9.994 0l-.725.697-.001.001-8.98 8.64a.961.961 0 00.013 1.385 1.056 1.056 0 001.439.012l7.227-6.954v29.231c0 .546.46.988 1.027.988s1.026-.442 1.026-.988V3.782l7.227 6.953c.193.186.454.29.726.29.273 0 .534-.104.726-.29a.968.968 0 00.301-.698.968.968 0 00-.301-.699"}})])
          )
        }
      }
    